import {Loading} from 'components/LoadingComponents/loading';
import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

/**
 *
 * @param {Object} props props of the component
 * @property {boolean} [props.loadingNext]
 * @property {number} props.displayCount
 * @property {number} props.totalCount
 *
 * @returns
 */
const Pagination = (props) => {
  const {t} = useTranslation();
  return (
    <>
      {props.loadingNext && (
        <div
          style={{height: '0'}}
          className={
            'd-flex justify-content-center align-items-center ' +
            (props.customClassName || 'loader_top')
          }
        >
          <Loading style={{transform: "translateY('2rem')"}} />
        </div>
      )}
      {!!props.displayCount && (
        <div
          className={
            'd-flex justify-content-end font-medium text px-auto ' +
            (props.className || '')
          }
        >
          <div className="pagination-box">
            <div className="page-seen-count">{1}</div> -{' '}
            <div className="page-display-count">{props.displayCount || 0}</div>{' '}
            {t('of')}
            <div className="page-total">{props.totalCount}</div>
          </div>
        </div>
      )}
    </>
  );
};

export default Pagination;
